<div class="container-fluid customers-root">
  <!-- View Details implemented: -->
  <div class="view-details-container" *ngIf="detailsShowed">
    <app-add-survey [isPopUp]="true" (closePopUpChange)="detailsShowed = false; reloadTable()"></app-add-survey>
  </div>
  <app-card-analytics [stats]="stats" [reset]="reset" (shareFilterValue)="onFilterBy($event)"></app-card-analytics>

  <div class="table-root">
    <div class="d-flex justify-content-start switch-toggle transparent">
      <a class="separated-toggle-item" [ngClass]="currentTab == 4 ? 'active' : ''"
        (click)="changeTab(4);reset = !reset">
        <div><span class="bubble">{{countAssigned | number}}</span> {{'COMMON.ASSET_STATUS.ASSIGNED' | translate}}</div>
      </a>
      <a class="separated-toggle-item" [ngClass]="currentTab == 1 ? 'active' : ''"
        (click)="changeTab(1);reset = !reset">
        <div><span class="bubble">{{countSubmited | number}}</span> {{'COMMON.ASSET_STATUS.SUBMITTED' | translate}}
        </div>
      </a>
      <a class="separated-toggle-item" [ngClass]="currentTab == 2 ? 'active' : ''"
        (click)="changeTab(2);reset = !reset">
        <div><span class="bubble">{{countApproved | number}}</span> {{'COMMON.ASSET_STATUS.APPROVED' | translate}}</div>
      </a>
      <a class="separated-toggle-item" [ngClass]="currentTab == 3 ? 'active' : ''"
        (click)="changeTab(3);reset = !reset">
        <div><span class="bubble">{{countRejected | number}}</span> {{'COMMON.ASSET_STATUS.REJECTED' | translate}}</div>
      </a>
    </div>
    <div class="table-root-child">
      <div class="table-action-wrapper d-flex align-items-center justify-content-between">
        <div id="survey_search" class="search-input">
          <img src="../../assets/icons/search.svg" alt="Search icon" (click)="search()">
          <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="searchText"
            (keydown.enter)="search()" (ngModelChange)="this.searchTextUpdate.next($event)">
        </div>
        <div id="survey_search-by" class="search-type-picker">
          <div [title]="selectedSearchTypeDisplay | translate" class="dropdown"
            (click)="showSelectSearchType = !showSelectSearchType" click-stop-propagation>
            <span>{{'COMMON.BY' | translate}}:</span>
            <span>{{ selectedSearchTypeDisplay | translate }}</span>
            <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
          </div>
          <div class="dropdown-opened" *ngIf="showSelectSearchType">
            <div [id]="'survey_search-by-' + (i + 1)" (click)="selectSearchType(searchType)"
              *ngFor="let searchType of searchByOptions; let i = index">
              <div>{{ searchType.translation | translate }}</div>
            </div>
          </div>
        </div>
        <div class="ml-auto d-flex">
          <div>
            <div class="d-flex">
              <div id="survey_date-from" class="datepicker-container" style="width: 24rem;">
                <label for="dateFrom">
                  {{'COMMON.FROM' | translate}}:
                </label>
                <input type="date" id="dateFrom" name="dateFrom"
                  [ngClass]="(dateFrom>dateTo) ? 'btn datepicker-icon-error' : 'btn datepicker-icon'"
                  [(ngModel)]="dateFrom" (change)="datesValid()==true && search()">

              </div>



              <div id="survey_date-to" class="datepicker-container">
                <label for="dateTo" class="right-label">
                  {{'COMMON.TO' | translate}}:
                </label>
                <input type="date" id="dateTo" name="dateTo"
                  [ngClass]="(dateFrom>dateTo) ? 'btn datepicker-icon-error' : 'btn datepicker-icon'"
                  [(ngModel)]="dateTo" (change)="datesValid()==true && search()">

              </div>
            </div>
          </div>

          <div id="survey_filter-by" class="sort-by-root" (click)="showFilterBy=!showFilterBy;" click-stop-propagation>
            <div class="dropdown">
              <span>{{'COMMON.FILTER_BY' | translate}} {{'COMMON.TYPE' | translate | lowercase}}:</span>
              <span>{{filterByName | translate}}</span>
              <span><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down"></span>
            </div>
            <div class="dropdown-opened" *ngIf="showFilterBy">
              <div id="survey_filter-by-all" (click)="filterByType(filterByOptions.ALL)">
                {{'COMMON.FILTER_BY_OPTIONS.ALL' | translate}}</div>
              <div id="survey_filter-by-wall" (click)="filterByType(filterByOptions.WALL)">
                {{'COMMON.FILTER_BY_OPTIONS.WALL' | translate}}</div>
              <div id="survey_filter-by-pole" (click)="filterByType(filterByOptions.POLE)">
                {{'COMMON.FILTER_BY_OPTIONS.POLE' | translate}}</div>
            </div>
          </div>
          <button class="btn btn-icon" (click)="download()">
            <span>{{'COMMON.DOWNLOAD' | translate}}</span>
          </button>
          <div class="xlsx-upload-wrapper" *ngIf="currentTab==4 && permissionsService.isSurveyCreateEditAllowed">
            <button class="btn btn-primary btn-upload" (click)="showUpload=!showUpload;" click-stop-propagation>
              <img src="../../assets/icons/chevron-down.svg" alt="Chevron down">
            </button>
            <div *ngIf="showUpload" class="xlsx-upload-dropdown">
              <div class="xlsx-upload" [routerLink]="'/upload/6/' + utilityId">
                <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload icon" /></div>
                <div>{{'COMMON.UPLOAD_XLSX' | translate}}</div>
              </div>
              <div *ngIf="permissionsService.isSurveyAssignMapVendorAllowed" class="xlsx-upload" [routerLink]="'/upload/37/' + utilityId">
                <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload icon" /></div>
                <div>{{'SURVEYS.BULK_VENDOR_REASSIGNMENT' | translate}}</div>
              </div>
              <div *ngIf="permissionsService.isSurveyAssignToVendorAllowed" class="xlsx-upload" [routerLink]="'/upload/33/' + utilityId">
                <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload icon" /></div>
                <div>{{'NEW_SERVICE.BULK_ASSIGN_VENDOR' | translate}}</div>
              </div>
            </div>
          </div>
          <!-- <button class="btn btn-primary btn-add-new" (click)="openCreateModal()"
            *ngIf="currentTab==4 && permissionsService.isSurveyCreateEditAllowed">
            <img src="../../assets/icons/plus.svg" alt="Plus icon">
            <span>{{'SURVEYS.NEW' | translate}}</span>
          </button> -->
        </div>
      </div>


      <div class="filter">
        <div class="filter-list">
          {{'COMMON.FILTER' | translate}}
          <app-multi-select-dropdown class="multiselect" id="survey_region_filter" [clicked]="clicked" [items]="hasCimDataIntegration ? geographicalRegions : regions"
            [label]="'COMMON.BU.PLURAL'" [showMore]="false" [requireApply]="true"
            (shareIndividualCheckedList)="hasCimDataIntegration ? selectGeographicalRegion($event) : selectRegion($event)" (applyFilterEmitter)="reloadTable(1)">
          </app-multi-select-dropdown>
          <app-multi-select-dropdown class="multiselect" id="survey_area_filter" [clicked]="clicked" [items]="hasCimDataIntegration ? subGeographicalRegions : areas"
            [label]="'COMMON.UT.PLURAL'" [showMore]="false" [requireApply]="true"
            (shareIndividualCheckedList)="selectArea($event)" (applyFilterEmitter)="reloadTable(1)">
          </app-multi-select-dropdown>
          <select id="survey_tariff_filter" name="tariff-select" (change)="selectTariff($event)" class="form-select">
            <option value="0" [selected]="tariff == 0" disabled>{{'COMMON.TARIFF.SINGLE' | translate}}</option>
            <option [id]="'survey_tariff_filter-' + (i + 1)" [selected]="tariff == o.id"
              *ngFor="let o of tariffs; let i = index" value="{{o.id}}">
              {{o.name}}
            </option>
          </select>



          <select id="survey_customer-type_filter" name="type-select" (change)="selectCustomerType($event)"
            class="form-select">
            <option value="0" [selected]="customerType == 0" disabled>{{'COMMON.MBC_DETAILS.CUSTOMER_TYPE' | translate}}
            </option>
            <option [id]="'survey_customer-type_filter-' + (i + 1)" [selected]="customerType == o.value"
              *ngFor="let o of customerTypeOptions; let i = index" value="{{o.value}}">
              {{o.translation | translate}}
            </option>
          </select>
          <select id="survey_cutomer-phase_filter" name="phase-select" (change)="selectCustomerPhase($event)"
            class="form-select">
            <option value="0" [selected]="customerPhase == -1" disabled>{{'COMMON.CUSTOMER.CUSTOMER_PHASE' | translate}}
            </option>
            <option [id]="'survey_customer-phase_filter-' + (i + 1)" [selected]="customerPhase == o.value"
              *ngFor="let o of customerPhaseOptions; let i = index" value="{{o.value}}">
              {{o.translation | translate}}
            </option>
          </select>
          <select id="survey_meter-status_filter" name="status-select" (change)="selectMeterStatus($event)"
            class="form-select">
            <option value="0" [selected]="meterStatus == 0" disabled>{{'COMMON.MBC_DETAILS.METER_STATUS' | translate}}
            </option>
            <option [id]="'survey_meter-status_filter-' + (i + 1)" [selected]="meterStatus == o.value"
              *ngFor="let o of meterStatusOptions; let i = index" value="{{o.value}}">
              {{o.translation | translate}}
            </option>
          </select>
          <select id="survey_survey-status_filter" *ngIf="currentTab==1" name="survey-status-select"
            (change)="selectSurveyStatus($event)" class="form-select">
            <option value="0" [selected]="surveyStatus == 0" disabled>{{'SURVEYS.STATUS' | translate}}</option>
            <option [id]="'survey_survey-status_filter-' + (i + 1)" [selected]="surveyStatus == o.value"
              *ngFor="let o of surveyStatusOptions; let i = index" value="{{o.value}}">
              {{o.translation | translate}}
            </option>
          </select>
          <select id="survey_map-vendor_filter" name="map-vendor-select" (change)="selectMapVendor($event)"
            class="form-select">
            <option value="0" [selected]="selectedOrganizationId == 0" disabled>{{'SURVEYS.MAP_VENDOR' | translate}}
            </option>
            <option [id]="'survey_map-vendor_filter-' + (i + 1)" [selected]="selectedOrganizationId == o.id"
              *ngFor="let o of organizations; let i = index" value="{{o.id}}">
              {{o.name}}
            </option>
          </select>
          <select id="survey_payment-status_filter" name="payment-status-select" (change)="selectPaymentStatus($event)"
            class="form-select">
            <option value="0" [selected]="paymentStatus == 0" disabled>{{'COMMON.PAYMENT_STATUS.SINGLE' | translate}}
            </option>
            <option [id]="'survey_payment-status_filter-' + (i + 1)" [selected]="paymentStatus == o.value"
              *ngFor="let o of paymentStatusOptions; let i = index" value="{{o.value}}">
              {{o.translation | translate}}
            </option>
          </select>
          <select id="survey_due-date_filter" name="due-date-select" (change)="selectDueDateFilter($event)"
            class="form-select" *ngIf="currentTab==4 || currentTab==3">
            <option value="0" [selected]="dueDateFilter == -1" disabled>{{'COMMON.DATE_TYPE.DUE_DATE' | translate}}
            </option>
            <option [id]="'survey_due-date_filter-' + (i + 1)" [selected]="dueDateFilter == o.value"
              *ngFor="let o of dueDateFilterOptions; let i = index" value="{{o.value}}">
              {{o.translation | translate}}
            </option>
          </select>
          <select id="survey_reopen-status_filter" name="reopen-status-select" (change)="selectReopenStatus($event)"
            class="form-select">
            <option value="0" [selected]="reopenStatus == 0" disabled>{{'SURVEYS.REQUEST_INSTANCE' | translate}}
            </option>
            <option [id]="'survey_reopen-status_filter-' + (i + 1)" [selected]="reopenStatus == o.value"
              *ngFor="let o of reopenStatusOptions; let i = index" value="{{o.value}}">
              {{o.translation | translate}}
            </option>
          </select>
        </div>
        <div *ngIf="selectedFilters.length > 0">
          <app-filter-checklist [filters]="selectedFilters" (resetFilterEmitter)="resetFilter($event)"
            (removeFilterEmitter)="removeFilter($event)">
          </app-filter-checklist>
        </div>
      </div>
      <div class="table">
        <div *ngIf="surveys">
          <div class="table-scroll">
          <table class="table border-bottom">
            <thead class="table-light">
              <tr>
                <th id="survey_table_header_checkbox"><input type="checkbox" class="form-check-input"
                    [checked]="isAllCheckBoxChecked()" (change)="checkAllCheckBox($event)"></th>
                <th id="survey_table_header_survey-id">{{'SURVEYS.ID' | translate}}</th>
                <th id="survey_table_header_acc-no">{{'COMMON.MBC_DETAILS.ACCOUNT_NO' | translate}}</th>
                <th id="survey_table_header_building-owner">{{'COMMON.TABLE_HEADERS.BUILDING_OWNER' | translate}}</th>
                <th id="survey_table_header_address">{{'COMMON.ADDRESS' | translate}}</th>
                <th id="survey_table_header_current-tariff">{{'COMMON.CURRENT_TARIFF' | translate}}</th>
                <th id="survey_table_header_region">{{'COMMON.BU.SINGLE' | translate}}</th>
                <th id="survey_table_header_district">{{'COMMON.UT.SINGLE' | translate}}</th>
                <th id="survey_table_header_feeder">{{'COMMON.FEEDER' | translate}}</th>
                <th id="survey_table_header_dt">{{'TRANSFORMERS.DT' | translate}}</th>
                <th id="survey_table_header_meter-no">{{'COMMON.MBC_DETAILS.METER_NO' | translate}}</th>
                <th id="survey_table_header_assigned-date" *ngIf="currentTab==4">
                  {{'COMMON.TABLE_HEADERS.ASSIGNED_DATE' | translate}}</th>
                <th id="survey_table_header_submitted-date" *ngIf="currentTab==1">
                  {{'COMMON.TABLE_HEADERS.SUBMITTED_DATE' | translate}}</th>
                <th id="survey_table_header_rejected-date" *ngIf="currentTab==3">{{'COMMON.TABLE_HEADERS.REJECTED_DATE'
                  | translate}}</th>
                <th id="survey_table_header_approved-date" *ngIf="currentTab==2">{{'COMMON.TABLE_HEADERS.APPROVED_DATE'
                  | translate}}</th>
                <th id="survey_table_header_assigned">{{'COMMON.MBC_DETAILS.ASSIGNED' | translate}}</th>
                <th id="survey_table_header_assigned-by" *ngIf="currentTab==1 || currentTab==4">
                  {{'COMMON.TABLE_HEADERS.ASSIGNED_BY' | translate}}</th>
                <th id="survey_table_header_rejected-by" *ngIf="currentTab==3">{{'COMMON.TABLE_HEADERS.REJECTED_BY' |
                  translate}}</th>
                <th id="survey_table_header_approved-by" *ngIf="currentTab==2">{{'COMMON.TABLE_HEADERS.APPROVED_BY' |
                  translate}}</th>
                <th id="survey_table_header_map-id">{{'SURVEYS.MAP_ID' | translate}}</th>
                <th id="survey_table_header_project-type">{{'SURVEYS.PROJECT_TYPE' | translate}}</th>
                <th id="survey_table_header_map-vendor">{{'SURVEYS.MAP_VENDOR' | translate}}</th>
                <th id="survey_table_header_payment-status">{{'COMMON.PAYMENT_STATUS.SINGLE' | translate}}</th>
                <th id="survey_table_header_due-date" *ngIf="currentTab==4 || currentTab==3">{{'COMMON.DATE_TYPE.DUE_DATE' | translate}}</th>
                <th id="survey_table_header_current-status">{{'SURVEYS.REQUEST_INSTANCE' | translate}}</th>
                <th id="survey_table_header_current-status">{{'COMMON.TABLE_HEADERS.CURRENT_STATUS' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr [id]="'survey_table_row-' + (i + 1)" *ngFor="let survey of surveys; let i=index;">
                <td [id]="'survey_table_checkbox-' + (i + 1)"><input type="checkbox" class="form-check-input"
                    value="{{survey.id}}"></td>
                <td [id]="'survey_table_survey-id-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{survey?.id | hasValue}}</td>
                <td [id]="'survey_table_acc-no-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{survey.accountNo | hasValue}}</td>
                <td [id]="'survey_table_acc-name-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{survey.accountName | hasValue}} </td>
                <td [id]="'survey_table_address-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{survey.address | hasValue}} </td>
                <td [id]="'survey_table_current-tariff-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{survey.currentTariff | hasValue}} </td>
                <td [id]="'survey_table_region-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{(hasCimDataIntegration ? survey.geographicalRegion : survey.region) | hasValue}} </td>
                <td [id]="'survey_table_district-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{(hasCimDataIntegration ? survey.subgeographicalRegion : survey.district) | hasValue}} </td>
                <td [id]="'survey_table_feeder-name-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{(hasCimDataIntegration ? survey.acLineName : survey.feederName) | hasValue}} </td>
                <td [id]="'survey_table_dt-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{(hasCimDataIntegration ? survey.substationName : survey.dtName) | hasValue}} </td>
                <td [id]="'survey_table_old-meter-no-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{survey.oldMeterNo | hasValue}} </td>
                <td [id]="'survey_table_assigned-date-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]" *ngIf="currentTab==4">{{survey.assignedDate |
                  hasValue}} </td>
                <td [id]="'survey_table_submitted-date-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]" *ngIf="currentTab==1">{{survey.submittedDate |
                  hasValue}} </td>
                <td [id]="'survey_table_rejected-date-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]" *ngIf="currentTab==3">{{survey.rejectedDate | hasValue}} </td>
                <td [id]="'survey_table_approved-date-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]" *ngIf="currentTab==2">{{survey.approvedDate | hasValue}} </td>
                <td [id]="'survey_table_assigned-user-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{survey.assignedUser | hasValue}} </td>
                <td [id]="'survey_table_assigned-by-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]" *ngIf="currentTab==1 || currentTab==4">{{survey.assignedBy |
                  hasValue}} </td>
                <td [id]="'survey_table_rejected-by-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]" *ngIf="currentTab==3">{{survey.rejectedBy | hasValue}} </td>
                <td [id]="'survey_table_approved-by-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]" *ngIf="currentTab==2">{{survey.approvedBy | hasValue}} </td>
                <td [id]="'survey_table_map-id-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{survey.mapId | hasValue}}</td>
                <td [id]="'survey_table_project-type-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{survey.projectType | hasValue}}</td>
                <td [id]="'survey_table_map-vendor-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">{{survey.mapVendorName | hasValue}}</td>
                <td [id]="'survey_table_payment-status-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">
                  <div *ngIf="survey.paymentStatus !== '/'" class="building-status" [ngClass]="{'assigned-building': survey.paymentStatus == 'Refunded' || survey.paymentStatus == 'Unknown', 
                                       'rejected-building': survey.paymentStatus == 'Failed', 
                                       'approved-building': survey.paymentStatus == 'Success' || survey.paymentStatus == 'ReadyForPayout',
                                       'submitted-building': survey.paymentStatus=='Pending'
                                      }">
                    {{'COMMON.PAYMENT_STATUS.' + survey.paymentStatus | uppercase | translate}}
                  </div>
                  <div *ngIf="survey.paymentStatus === '/'" class="building-status">
                    {{'COMMON.PAYMENT_STATUS.NOT_PAID' | translate}}
                  </div>
                </td>
                 <td [id]="'survey_table_due-date-' + (i + 1)" *ngIf="currentTab==4 || currentTab==3" (click)="setFilterStorage()"
                        [routerLink]="['details', survey.id]">
                  <div>{{ survey.dueDate ? (survey.dueDate | date:'dd/MM/yyyy') : ('COMMON.DUE_DATE_FILTER_OPTIONS.NOT_DUE' | translate) }}</div>
                  <div *ngIf="getTimelineStatus(survey.dueDate) as timeline"
                    [ngClass]="timeline.overdue ? 'timeline-overdue' : 'timeline-remaining'">
                    <ng-container *ngIf="!timeline.overdue && timeline.days === 0">
                      {{ 'SURVEYS.TIMELINE.DUE_TODAY' | translate }}
                    </ng-container>
                    <ng-container *ngIf="!timeline.overdue && timeline.days > 0">
                      {{ (timeline.days === 1 ? 'SURVEYS.TIMELINE.DAY_REMAINING' : 'SURVEYS.TIMELINE.DAYS_REMAINING') | translate:{ days: timeline.days } }}
                    </ng-container>
                    <ng-container *ngIf="timeline.overdue">
                      {{ (timeline.days === 1 ? 'SURVEYS.TIMELINE.DAY_OVERDUE' : 'SURVEYS.TIMELINE.DAYS_OVERDUE') | translate:{ days: timeline.days } }}
                    </ng-container>
                  </div>
                </td>
                <td [id]="'survey_table_reopen-status-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">
                  <div *ngIf="survey.reopenStatus">
                    {{'SURVEYS.REOPEN_STATUS.' + survey.reopenStatus | uppercase | translate}}
                  </div>
                  <div *ngIf="!survey.reopenStatus">{{ survey.reopenStatus | hasValue }}</div>
                </td>
                <td [id]="'survey_table_current-status-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', survey.id]">
                  <div *ngIf="survey.currentStatus" class="building-status" [ngClass]="{'assigned-building': survey.currentStatus == 'Assigned', 
                                       'rejected-building': survey.currentStatus == 'Rejected', 
                                       'approved-building': survey.currentStatus == 'Approved',
                                       'unvalidated-building': survey.currentStatus == 'Unvalidated', 
                                       'submitted-building': survey.currentStatus == 'Submitted'|| survey.currentStatus=='Pending'
                                      }">
                    {{'COMMON.ASSET_STATUS.' + survey.currentStatus | uppercase | translate}}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
          <div>
            <app-paging *ngIf="count > 0" [pageSize]="pageSize" [count]="count" [currentPage]="currentPage"
              [useDirect]="true" (pageChange)="pageChange($event)"></app-paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>